export default "__VITE_ASSET__B1s9Hy_r__"